import { Injectable } from '@angular/core';
import { select, Store } from "@ngrx/store";
import { take, tap } from "rxjs/operators";
import { SearchCustomersService } from '@modules/search-customers/search-customers.service';
import { PermissionRemoveAction } from 'src/app/modules/permissions/store/permisssion.actions';
import { RoleDeleteAction } from 'src/app/modules/roles/store/role.actions';
import { selectRolesState } from 'src/app/modules/roles/store/role.selector';
import { IStoreState } from 'src/app/store/store.state';
import { UserDeleteAction } from 'src/app/modules/users/store/user.actions';
import { User } from "@modules/users/users.interface";
import { ErrorService } from "@services/error.service";

@Injectable({
  providedIn: 'root'
})
export class ModalActionsService {

  constructor(
    private store: Store<IStoreState>,
    private errorService: ErrorService,
    private searchCustomersService: SearchCustomersService,
  ) {
  }

  modalAction(modalData: any) {
    switch (modalData.name) {

      case "Cancella Utente":
        this.handleDeleteUser(modalData.object);
        break;

      case "Cancella Ruolo":
        this.handleDeleteRole(modalData.object);
        break;

      case "Cancella Permesso":
        this.handleDeletePermission(modalData.object);
        break;

      case "Cancella Utente IrenYou":
        this.handleDeleteUserIrenYou(modalData.object);
        break;

      default:
        break;
    }
  }

  //AZIONE ESEGUITA IN USER COMPONENT
  private handleDeleteUser(user: User) {
    this.store.dispatch(UserDeleteAction({ user: user }))
  }

  //AZIONE ESEGUITA IN ROLE COMPONENT
  private handleDeleteRole(idRuolo: string) {
    this.store.pipe(
      select(selectRolesState),
      tap(ruoli => {
        let ruoloUtente;
        ruoloUtente = ruoli.find(r => {
          return ((r.id_ruolo === Number(idRuolo)) && (r.ruolo.toLowerCase() === 'utente'))
        })
        if (ruoloUtente) {
          const errorMessage = "Questo ruolo non è possibile cancellarlo perché è il ruolo master dell'applicazione.";
          this.errorService.setError(errorMessage);
        }
      }),
      take(1)
    ).subscribe(() => {
      this.store.dispatch(RoleDeleteAction({ id: idRuolo }))
    }, error => {
      this.errorService.setError(error.message);
    })
  }

  //AZIONE ESEGUITA IN PERMISSION COMPONENT
  handleDeletePermission(id_permesso: string) {
    this.store.dispatch(PermissionRemoveAction({ permissionId: id_permesso }))
  }

  //AZIONE ESEGUITA IN SEARCH CUSTOMER COMPONENT
  private handleDeleteUserIrenYou(utente: any) {
    this.searchCustomersService.deleteAccount(utente).subscribe();
  }
}
